import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { MenuDataService } from './data/menu/menu-data.service';
import { SubscriptionDataService } from './data/subscription/subscription-data.service';
import { ProductP } from './data/crm-client-api';
import { AuthService } from './core/authentication/auth.service';
import { AuthKey } from './data/auth-key.enum';
import { AlertService } from './core/alert/alert.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Location } from '@angular/common';
import { MetaService } from './data/meta/meta.service';
import { SeoService } from './data/seo/seo-service.service';

declare var SmartBanner: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit {
  public cheapestPackage: ProductP;
  anonToken: any = null;
  hastoken: boolean = false;
  isBlocked: boolean = false;
  staticTitle: string = "sportstv";
  title: string;
  urlHistory: string[] = [];

  constructor(private service: MenuDataService,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private seoService: SeoService
    //private meta: MetaService
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        (<any>window).ga('set', 'page', event.urlAfterRedirects);
        (<any>window).ga('send', 'pageview');

        if (this.urlHistory.length < 3) {
          this.urlHistory.push(event.url);
          sessionStorage.setItem("urlhistory", JSON.stringify(this.urlHistory));
        }
      }
    });
    this.getAnonToken();
    this.title = this.staticTitle;

  }

  ngOnInit() {
    //this.meta.updateTitle();
    this.seoService.generateTags({
      title: 'sportstv',
      url: this.router.url,
      description: "sportstv Platform, sporun her branşını kapsayan yayıncılık anlayışıyla hareket eden bir premium içerik yaratıcısı; geliştiricisi; sağlayıcısı olmakla birlikte kapsamlı bir OTT platformudur. ",
      //slug: 'dashboard'
    });
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
      // this.getContent();
    });


  }
  bodyElement: any;
  ngAfterViewInit(): void {
    this.bodyElement = document.getElementById('sportstv-body');
    this.bodyElement.style.backgroundColor = localStorage.getItem('backgroundcolor');

    if (!document.URL.includes('avrupaoyunlari.sportstv.com.tr/platform')) {
      this.showSmartBanner();
    }
  }


  getAnonToken() {
    this.authService.getAnonToken().subscribe(data => {
      if (data.code == 200) {
        localStorage.setItem(AuthKey.ANON_TOKEN, data.data);
        this.hastoken = true;
      }
      else if (data.code == 900) {
        this.isBlocked = true;
      }
      else {
        this.hastoken = false;
      }
    })
  }


  showSmartBanner() {

    new SmartBanner({
      daysHidden: 15,   // days to hide banner after close button is clicked (defaults to 15)
      daysReminder: 90, // days to hide banner after "VIEW" button is clicked (defaults to 90)
      appStoreLanguage: null, // language code for the App Store (defaults to user's browser language)
      title: 'sportstvPLATFORM',
      author: 'VO2MOBILE',
      button: 'Görüntüle',
      store: {
        ios: "App Store'da",
        android: "Google Play'de",
        windows: 'In Windows store'
      },
      price: {
        ios: 'Ücretsiz',
        android: 'Ücretsiz',
        windows: 'Ücretsiz'
      }
      // , theme: '' // put platform type ('ios', 'android', etc.) here to force single theme on all device
      // , icon: '' // full path to icon image if not using website icon image
      // , force: 'ios' // Uncomment for platform emulation
    });
  }

}





// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/app.component.ts